import NavMenu from '../../components/navbar/NavMenu'
import TitleBar from '../../components/navbar/TitleBar'
import StopSchedule from '../../components/stops/StopSchedule'
import Footer from '../../components/common/Footer'
export default function StopSchedulePage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <StopSchedule/>
            <Footer/>
        </>
    )
}
